import { ShareProps, SocialShareButton } from './SocialShareButton.component';
import { TagCommanderService } from 'features/tagCommander/business/TagCommander.service';
import React, { ComponentProps, FC } from 'react';
import { SocialNetwork } from '@actus/types';
import { Text } from '@components/Text/Text.component';
import classnames from 'classnames';

interface Props extends Omit<ShareProps, 'socialNetwork'> {
  orientation?: 'horizontal' | 'vertical';
  socialNetworks?: SocialNetwork[];
  iconSize?: number;
  withPrefix?: boolean;
}

const defaultNetworks = [SocialNetwork.Facebook, SocialNetwork.Linkedin, SocialNetwork.Twitter];

const SocialShareBar: FC<Props & ComponentProps<'div'>> = ({
  orientation = 'horizontal',
  socialNetworks = defaultNetworks,
  className,
  imgUrl,
  imgAlt,
  title,
  description,
  iconSize = 30,
  withPrefix = false,
  ...rest
}) => {
  const direction = orientation === 'vertical' ? 'column' : 'row';
  const rootClass = classnames('social-share-bar inline-flex align-center', direction, className);
  const socialShareClassName = orientation === 'vertical' ? 'plc-mb-s' : 'plc-mr-s';
  const prefixClassName = orientation === 'vertical' ? 'plc-mb-m' : 'plc-mr-m';

  return (
    <div className={rootClass} {...rest}>
      {withPrefix && <Text className={prefixClassName} i18nKey="common.share-prefix" tag="div" variant="h4" />}
      {socialNetworks.map(sn => (
        <SocialShareButton
          key={sn}
          className={socialShareClassName}
          description={description}
          iconSize={iconSize}
          imgAlt={imgAlt}
          imgUrl={imgUrl}
          // eslint-disable-next-line react/jsx-no-bind
          onClick={event =>
            TagCommanderService.triggerEvent('click', event.currentTarget, {
              button_name: sn,
            })
          }
          socialNetwork={sn}
          title={title}
        />
      ))}
    </div>
  );
};

export { SocialShareBar };
